export const createStars = () => {
    const container = document.querySelector('.stars-container');
    if (!container) return;
    container.innerHTML = '';

    // Reduced from 400 to 120 - still looks great, much lighter
    const starCount = 120;
    const fragment = document.createDocumentFragment();

    for (let i = 0; i < starCount; i++) {
        const star = document.createElement('div');
        star.className = 'star';
        star.style.top = `${Math.random() * 100}%`;
        star.style.left = `${Math.random() * 100}%`;

        const rnd = Math.random();
        if (rnd > 0.97) {
            star.classList.add('star-large');
        } else if (rnd > 0.92) {
            star.classList.add('star-medium');
        } else if (rnd > 0.85) {
            star.classList.add('star-small');
        }

        star.style.opacity = (Math.random() * 0.7 + 0.3).toString();
        star.style.animationDelay = `${Math.random() * 10}s`;
        star.style.animationDuration = `${Math.random() * 3 + 2}s`;

        fragment.appendChild(star);
    }

    // Reduced from 15 to 5 shooting stars
    const shootingStarCount = 5;
    for (let i = 0; i < shootingStarCount; i++) {
        const shootingStar = document.createElement('div');
        shootingStar.className = 'shooting-star';
        shootingStar.style.top = `${Math.random() * 70}%`;
        shootingStar.style.left = `${Math.random() * 100}%`;
        shootingStar.style.animationDelay = `${Math.random() * 15}s`;
        shootingStar.style.animationDuration = `${Math.random() * 2 + 1}s`;
        fragment.appendChild(shootingStar);
    }

    container.appendChild(fragment);
};

export const createParticles = () => {
    const container = document.querySelector('.particles-container');
    if (!container) return;
    container.innerHTML = '';

    // Reduced from 80 to 25
    const particleCount = 25;
    const fragment = document.createDocumentFragment();

    for (let i = 0; i < particleCount; i++) {
        const particle = document.createElement('div');
        particle.className = 'particle';
        particle.style.top = `${Math.random() * 100}%`;
        particle.style.left = `${Math.random() * 100}%`;

        const size = Math.random() * 8 + 1;
        particle.style.width = `${size}px`;
        particle.style.height = `${size}px`;

        if (Math.random() > 0.9) {
            particle.classList.add('particle-glow-strong');
        } else if (Math.random() > 0.7) {
            particle.classList.add('particle-glow');
        }

        particle.style.opacity = (Math.random() * 0.2 + 0.05).toString();
        particle.style.animationDelay = `${Math.random() * 20}s`;
        particle.style.animationDuration = `${Math.random() * 40 + 20}s`;

        fragment.appendChild(particle);
    }

    container.appendChild(fragment);
};

export const createLightRays = () => {
    const container = document.querySelector('.light-rays-container');
    if (!container) return;
    container.innerHTML = '';

    // Reduced from 8 to 4
    const rayCount = 4;
    const fragment = document.createDocumentFragment();

    for (let i = 0; i < rayCount; i++) {
        const ray = document.createElement('div');
        ray.className = 'light-ray';
        ray.style.top = `${Math.random() * 100}%`;
        ray.style.left = `${Math.random() * 100}%`;
        ray.style.transform = `rotate(${Math.random() * 360}deg)`;
        ray.style.opacity = (Math.random() * 0.05 + 0.02).toString();
        ray.style.animationDelay = `${Math.random() * 5}s`;
        ray.style.animationDuration = `${Math.random() * 10 + 10}s`;

        fragment.appendChild(ray);
    }

    container.appendChild(fragment);
};

export const createConstellations = () => {
    const container = document.querySelector('.constellations-container');
    if (!container) return;
    container.innerHTML = '';

    // Reduced from 4 to 2
    const constellationCount = 2;
    const fragment = document.createDocumentFragment();

    for (let c = 0; c < constellationCount; c++) {
        const constellation = document.createElement('div');
        constellation.className = 'constellation';
        constellation.style.top = `${20 + Math.random() * 60}%`;
        constellation.style.left = `${20 + Math.random() * 60}%`;

        const starCount = Math.floor(Math.random() * 4) + 5;
        const stars = [];

        for (let i = 0; i < starCount; i++) {
            const star = document.createElement('div');
            star.className = 'constellation-star';
            const x = Math.random() * 100 - 50;
            const y = Math.random() * 100 - 50;
            star.style.transform = `translate(${x}px, ${y}px)`;
            constellation.appendChild(star);
            stars.push({ x, y });
        }

        for (let i = 0; i < stars.length - 1; i++) {
            const line = document.createElement('div');
            line.className = 'constellation-line';

            const x1 = stars[i].x;
            const y1 = stars[i].y;
            const x2 = stars[i + 1].x;
            const y2 = stars[i + 1].y;

            const length = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
            const angle = Math.atan2(y2 - y1, x2 - x1) * 180 / Math.PI;

            line.style.width = `${length}px`;
            line.style.transform = `translate(${x1}px, ${y1}px) rotate(${angle}deg)`;
            line.style.transformOrigin = '0 0';

            constellation.appendChild(line);
        }

        fragment.appendChild(constellation);
    }

    container.appendChild(fragment);
};